import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import LrfService from '../../../../services/lrf-auth';
import { Link } from 'react-router-dom';



/*async function getLrf() {
    let resposta = await fetch('http://localhost:3000/api/lrf.json')
    let nvdiario = await resposta.json()
    return nvdiario
}*/



const Lrf = () => {
    const [bimestre, setBimestre] = useState("");
    const [ano, setAno] = useState("");
    const [error, setError] = useState([]);
    const [rreo1a, setRreo1a] = useState([]);
    const [rreo1b, setRreo1b] = useState([]);
    const [rreo2, setRreo2] = useState([]);
    const [rreo3, setRreo3] = useState([]);
    const [rreo4, setRreo4] = useState([]);
    const [rreo5, setRreo5] = useState([]);
    const [rreo6, setRreo6] = useState([]);
    const [rreo7, setRreo7] = useState([]);
    const [rreo8, setRreo8] = useState([]);
    const [rreo9, setRreo9] = useState([]);
    const [rreo10, setRreo10] = useState([]);
    const [rreo11, setRreo11] = useState([]);
    const [rreo12, setRreo12] = useState([]);
    const [rreo13, setRreo13] = useState([]);
    const [rreo14, setRreo14] = useState([]);
    const [rreo15, setRreo15] = useState([]);
    const [rreo16, setRreo16] = useState([]);
    const [rgf1, setRgf1] = useState([]);
    const [rgf2, setRgf2] = useState([]);
    const [rgf3, setRgf3] = useState([]);
    const [rgf4, setRgf4] = useState([]);
    const [rgf5, setRgf5] = useState([]);
    const [rgf6, setRgf6] = useState([]);
    const [rgf7, setRgf7] = useState([]);
    const [rgf8, setRgf8] = useState([]);
    const [dcrgf1, setDcrgf1] = useState([]);
    const [dcrgf2, setDcrgf2] = useState([]);
    const [dcrgf3, setDcrgf3] = useState([]);
    const [dcrgf4, setDcrgf4] = useState([]);
    const [dcrgf5, setDcrgf5] = useState([]);
    const [dcrgf6, setDcrgf6] = useState([]);
    const [dcrgf7, setDcrgf7] = useState([]);
    const [dcrgf8, setDcrgf8] = useState([]);
    const [sucesso, setSucesso] = useState(false);
    const [rreo, setRreo] = useState(false);
    const [rgf, setRgf] = useState(false);
    const [dcrgf, setDcrgf] = useState(false);

    /*const [novasDiarios, setNovas] = useState([]);

    useEffect(() => {
         getLrf().then(data => {
             setNovas(data['lrf'])
         })
     }, [])
 
     const enfiatudo = async () => {
         novasDiarios.map(async (item) => {
             const lrf = await LrfService.cadastro(
                 {
                     cod_lrf: parseInt(item.cod_lrf),
                     bimestre: item.bimestre,
                     ano: item.ano,
                     rreo: {
                         rreo1a: item.rreo1a,
                         rreo1b: item.rreo1b,
                         rreo2: item.rreo2,
                         rreo3: item.rreo3,
                         rreo4: item.rreo4,
                         rreo5: item.rreo5,
                         rreo6: item.rreo6,
                         rreo7: item.rreo7,
                         rreo8: item.rreo8,
                         rreo9: item.rreo9,
                         rreo10: item.rreo10,
                         rreo11: item.rreo11,
                         rreo12: item.rreo12,
                         rreo13: item.rreo13,
                         rreo14: item.rreo14,
                         rreo15: item.rreo15,
                         rreo16: item.rreo16
                     },
                     rgf: {
                        rgf1: item.rgf1,
                        rgf2: item.rgf2,
                        rgf3: item.rgf3,
                        rgf4: item.rgf4,
                        rgf5: item.rgf5,
                        rgf6: item.rgf6,
                        rgf7: item.rgf7,
                        rgf8: item.rgf8
                    },
                    dcrgf: {
                        dcrgf1: item.dcgf1,
                        dcrgf2: item.dcgf2,
                        dcrgf3: item.dcgf3,
                        dcrgf4: item.dcgf4,
                        dcrgf5: item.dcgf5,
                        dcrgf6: item.dcgf6,
                        dcrgf7: item.dcgf7,
                        dcrgf8: item.dcgf8
                    }
                 }
             )
             })}*/

    const trataBimestre = (bim) => {
        setBimestre(bim)
        switch (bim) {
            case "1bim":
            case "2bim":
            case "3bim":
            case "4bim":
            case "5bim":
            case "6bim":
                setRreo(true)
                setRgf(false)
                setDcrgf(false)
                break;
            case "1sem":
            case "2sem":
            case "1qua":
            case "2qua":
            case "3qua":
                setRgf(true)
                setRreo(false)
                setDcrgf(false)
                break;
            case "ano":
                setDcrgf(true)
                setRgf(false)
                setRreo(false)
                break;
        }
    }

    const handleUploadRreo1a = (e) => 
    {
        setRreo1a(e.target.files[0]);
    }
    const handleUploadRreo1b = (e) => 
    {
        setRreo1b(e.target.files[0]);
    }
    const handleUploadRreo2 = (e) => 
    {
        setRreo2(e.target.files[0]);
    }
    const handleUploadRreo3 = (e) => 
    {
        setRreo3(e.target.files[0]);
    }
    const handleUploadRreo4 = (e) => 
    {
        setRreo4(e.target.files[0]);
    }
    const handleUploadRreo5 = (e) => 
    {
        setRreo5(e.target.files[0]);
    }
    const handleUploadRreo6 = (e) => 
    {
        setRreo6(e.target.files[0]);
    }
    const handleUploadRreo7 = (e) => 
    {
        setRreo7(e.target.files[0]);
    }
    const handleUploadRreo8 = (e) => 
    {
        setRreo8(e.target.files[0]);
    }
    const handleUploadRreo9 = (e) => 
    {
        setRreo9(e.target.files[0]);
    }
    const handleUploadRreo10 = (e) => 
    {
        setRreo10(e.target.files[0]);
    }
    const handleUploadRreo11 = (e) => 
    {
        setRreo11(e.target.files[0]);
    }
    const handleUploadRreo12 = (e) => 
    {
        setRreo12(e.target.files[0]);
    }
    const handleUploadRreo13 = (e) => 
    {
        setRreo13(e.target.files[0]);
    }
    const handleUploadRreo14 = (e) => 
    {
        setRreo14(e.target.files[0]);
    }
    const handleUploadRreo15 = (e) => 
    {
        setRreo15(e.target.files[0]);
    }
    const handleUploadRreo16 = (e) => 
    {
        setRreo16(e.target.files[0]);
    }

    const handleUploadRgf1 = (e) => 
    {
        setRgf1(e.target.files[0]);
    }
    const handleUploadRgf2 = (e) => 
    {
        setRgf2(e.target.files[0]);
    }
    const handleUploadRgf3 = (e) => 
    {
        setRgf3(e.target.files[0]);
    }
    const handleUploadRgf4 = (e) => 
    {
        setRgf4(e.target.files[0]);
    }
    const handleUploadRgf5 = (e) => 
    {
        setRgf5(e.target.files[0]);
    }
    const handleUploadRgf6 = (e) => 
    {
        setRgf6(e.target.files[0]);
    }
    const handleUploadRgf7 = (e) => 
    {
        setRgf7(e.target.files[0]);
    }
    const handleUploadRgf8 = (e) => 
    {
        setRgf8(e.target.files[0]);
    }

    const handleUploadDcrgf1 = (e) => 
    {
        setDcrgf1(e.target.files[0]);
    }
    const handleUploadDcrgf2 = (e) => 
    {
        setDcrgf2(e.target.files[0]);
    }
    const handleUploadDcrgf3 = (e) => 
    {
        setDcrgf3(e.target.files[0]);
    }
    const handleUploadDcrgf4 = (e) => 
    {
        setDcrgf4(e.target.files[0]);
    }
    const handleUploadDcrgf5 = (e) => 
    {
        setDcrgf5(e.target.files[0]);
    }
    const handleUploadDcrgf6 = (e) => 
    {
        setDcrgf6(e.target.files[0]);
    }
    const handleUploadDcrgf7 = (e) => 
    {
        setDcrgf7(e.target.files[0]);
    }
    const handleUploadDcrgf8 = (e) => 
    {
        setDcrgf8(e.target.files[0]);
    }



    const montaForm = async () => {
        const lrf = new FormData();
        lrf.append("ano", ano)
        lrf.append("bimestre", bimestre)
        lrf.append("rreo1a", rreo1a);
        lrf.append("rreo1b", rreo1b);
        lrf.append("rreo2", rreo2);
        lrf.append("rreo3", rreo3);
        lrf.append("rreo4", rreo4);
        lrf.append("rreo5", rreo5);
        lrf.append("rreo6", rreo6);
        lrf.append("rreo7", rreo7);
        lrf.append("rreo8", rreo8);
        lrf.append("rreo9", rreo9);
        lrf.append("rreo10", rreo10);
        lrf.append("rreo11", rreo11);
        lrf.append("rreo12", rreo12);
        lrf.append("rreo13", rreo13);
        lrf.append("rreo14", rreo14);
        lrf.append("rreo15", rreo15);
        lrf.append("rreo16", rreo16);
        lrf.append("rgf1", rgf1);
        lrf.append("rgf2", rgf2);
        lrf.append("rgf3", rgf3);
        lrf.append("rgf4", rgf4);
        lrf.append("rgf5", rgf5);
        lrf.append("rgf6", rgf6);
        lrf.append("rgf7", rgf7);
        lrf.append("rgf8", rgf8);
        lrf.append("dcrgf1", dcrgf1);
        lrf.append("dcrgf2", dcrgf2);
        lrf.append("dcrgf3", dcrgf3);
        lrf.append("dcrgf4", dcrgf4);
        lrf.append("dcrgf5", dcrgf5);
        lrf.append("dcrgf6", dcrgf6);
        lrf.append("dcrgf7", dcrgf7);
        lrf.append("dcrgf8", dcrgf8);
        return lrf
    }

    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        const dados = await montaForm();
        try {
            const lrf = await LrfService.cadastro(dados)
            if (lrf.data["cod_lrf"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    const addNovo = (evt) => {
        evt.preventDefault()
        setSucesso(false)
        setAno("")
        setBimestre("")
        setError([]);
    }

    if (!sucesso) {
        return (
            <Fragment>
                {/*<Button onClick={enfiatudo}>Importar LRF</Button>*/}
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={2}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Bimestre">
                                <FloatingLabel
                                    label="Bimestre"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Bimestre"
                                        name="bimestre"
                                        onChange={e => trataBimestre(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="1bim">1º Bimestre (RREO)</option>
                                        <option value="2bim">2º Bimestre (RREO)</option>
                                        <option value="3bim">3º Bimestre (RREO)</option>
                                        <option value="1sem">1º Semestre (RGF)</option>
                                        <option value="4bim">4º Bimestre (RREO)</option>
                                        <option value="5bim">5º Bimestre (RREO)</option>
                                        <option value="6bim">6º Bimestre (RREO)</option>
                                        <option value="2sem">2º Semestre (RGF)</option>
                                        <option value="1qua">1º Quadrimestre (RGF)</option>
                                        <option value="2qua">2º Quadrimestre (RGF)</option>
                                        <option value="3qua">3º Quadrimestre (RGF)</option>
                                        <option value="ano">Anual (DCRGF)</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option>SELECIONE</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2026">2026</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {rreo ?
                    <Row xs={12} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo1a">
                                <Form.Label>RREO1A</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo1a}
                                    type="file"
                                    name="rreo1a"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo1b">
                                <Form.Label>RREO1B</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo1b}
                                    type="file"
                                    name="rreo1b"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo2">
                                <Form.Label>RREO2</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo2}
                                    type="file"
                                    name="rreo2"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo3">
                                <Form.Label>RREO3</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo3}
                                    type="file"
                                    name="rreo3"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo4">
                                <Form.Label>RREO4</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo4}
                                    type="file"
                                    name="rreo4"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo5">
                                <Form.Label>RREO5</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo5}
                                    type="file"
                                    name="rreo5"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo6">
                                <Form.Label>RREO6</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo6}
                                    type="file"
                                    name="rreo6"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo7">
                                <Form.Label>RREO7</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo7}
                                    type="file"
                                    name="rreo7"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo8">
                                <Form.Label>RREO8</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo8}
                                    type="file"
                                    name="rreo8"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo9">
                                <Form.Label>RREO9</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo9}
                                    type="file"
                                    name="rreo9"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo10">
                                <Form.Label>RREO10</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo10}
                                    type="file"
                                    name="rreo10"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo11">
                                <Form.Label>RREO11</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo11}
                                    type="file"
                                    name="rreo11"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo12">
                                <Form.Label>RREO12</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo12}
                                    type="file"
                                    name="rreo12"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo13">
                                <Form.Label>RREO13</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo13}
                                    type="file"
                                    name="rreo13"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo14">
                                <Form.Label>RREO14</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo14}
                                    type="file"
                                    name="rreo14"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo15">
                                <Form.Label>RREO15</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo15}
                                    type="file"
                                    name="rreo15"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rreo16">
                                <Form.Label>RREO16</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRreo16}
                                    type="file"
                                    name="rreo16"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                    </Row> : ''}
                    {rgf ?
                    <Row xs={12} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf1">
                                <Form.Label>RGF1</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf1}
                                    type="file"
                                    name="rgf1"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf2">
                                <Form.Label>RGF2</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf2}
                                    type="file"
                                    name="rgf2"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf3">
                                <Form.Label>RGF3</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf3}
                                    type="file"
                                    name="rgf3"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf4">
                                <Form.Label>RGF4</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf4}
                                    type="file"
                                    name="rgf4"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf5">
                                <Form.Label>RGF5</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf5}
                                    type="file"
                                    name="rgf5"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf6">
                                <Form.Label>RGF6</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf6}
                                    type="file"
                                    name="rgf6"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf7">
                                <Form.Label>RGF7</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf7}
                                    type="file"
                                    name="rgf7"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="rgf8">
                                <Form.Label>RGF8</Form.Label>
                                <Form.Control
                                    onChange={handleUploadRgf8}
                                    type="file"
                                    name="rgf8"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                    </Row> : ''}
                    {dcrgf ?
                    <Row xs={12} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf1">
                                <Form.Label>DCRGF1</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf1}
                                    type="file"
                                    name="dcrgf1"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf2">
                                <Form.Label>DCRGF2</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf2}
                                    type="file"
                                    name="dcrgf2"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf3">
                                <Form.Label>DCRGF3</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf3}
                                    type="file"
                                    name="dcrgf3"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf4">
                                <Form.Label>DCRGF4</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf4}
                                    type="file"
                                    name="dcrgf4"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf5">
                                <Form.Label>DCRGF5</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf5}
                                    type="file"
                                    name="dcrgf5"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf6">
                                <Form.Label>DCRGF6</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf6}
                                    type="file"
                                    name="dcrgf6"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf7">
                                <Form.Label>DCRGF7</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf7}
                                    type="file"
                                    name="dcrgf7"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="dcrgf8">
                                <Form.Label>DCRGF8</Form.Label>
                                <Form.Control
                                    onChange={handleUploadDcrgf8}
                                    type="file"
                                    name="dcrgf8"
                                    accept="application/pdf"
                                />
                            </Form.Group>
                        </Col>
                    </Row> : ''}
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Cadastrar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/lrf'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>LRF cadastrada com sucesso!</Alert>
                <Button onClick={addNovo} variant="success" type="submit">
                    Adicionar outra
                </Button>
                <br /><br />
                <Link to={'/restrito/lrf/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de LRF's
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/lrf'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Lrf;
